<template>
  <div class="card">
    <div class="card-header padding_12_20">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <div class="me-3">
            <img src="@/assets/images/svg-img/work-order.svg" />
          </div>
          <div>
            <div class="card_title_1">WORK ORDER MONITORING - GANGGUAN</div>
            <div class="card_title_2">Last Updated {{ last_update }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="card-body">
      <!-- <h5>ALL REGION</h5> -->
      <div class="container-fluid">
        <div class="page-title">
          <div class="row">
            <div class="col-6">
              <ol
                class="breadcrumb"
                style="text-transform: capitalize; justify-content: start"
              >
                <li
                  @click="bread('all')"
                  style="cursor: pointer"
                  class="breadcrumb-item"
                >
                  ALL REGION
                </li>
                <li
                  style="cursor: pointer"
                  @click="bread('uid')"
                  :class="activeUid ? 'active' : ''"
                  class="breadcrumb-item"
                  v-if="uid"
                >
                  {{ uid }}
                </li>
                <li
                  style="cursor: pointer"
                  @click="bread('up3')"
                  :class="activeUp3 ? 'active' : ''"
                  class="breadcrumb-item"
                  v-if="up3"
                >
                  {{ up3 }}
                </li>
                <li
                  style="cursor: pointer"
                  @click="bread('ulp')"
                  :class="activeUlp ? 'active' : ''"
                  class="breadcrumb-item"
                  v-if="ulp"
                >
                  {{ ulp }}
                </li>
                <!-- <li class="breadcrumb-item active" v-if="title">{{ title }}</li> -->
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div
        class="table-responsive"
        style="border: 1px solid #e5e7ed; border-radius: 8px; margin-top: 20px"
      >
        <table class="table">
          <thead style="--bs-table-bg: #f3f3f3">
            <tr>
              <th
                scope="col"
                style="
                  font-size: 14px;
                  font-weight: 400;
                  line-height: 16.41px;
                  letter-spacing: 0.02em;
                "
              >
                Regions
              </th>
              <th width="100px"></th>
              <th
                scope="col"
                style="
                  font-size: 10px;
                  font-weight: 400;
                  line-height: 9.38px;
                  letter-spacing: 0.02em;
                  text-align: -webkit-center;
                "
              >
                <div
                  class="m-b-5"
                  style="
                    width: 10px; /* Adjust size of the dot */
                    height: 10px; /* Same as width to ensure a perfect circle */
                    background-color: black; /* Replace with your desired color */
                    border-radius: 50%; /* Makes the div circular */
                  "
                ></div>
                <div>WO</div>
                <div>Belum Tindak Lanjut Over SLA</div>
              </th>
              <th
                scope="col"
                style="
                  font-size: 10px;
                  font-weight: 400;
                  line-height: 9.38px;
                  letter-spacing: 0.02em;
                  text-align: -webkit-center;
                "
              >
                <div
                  class="m-b-5"
                  style="
                    width: 10px; /* Adjust size of the dot */
                    height: 10px; /* Same as width to ensure a perfect circle */
                    background-color: #ff5151; /* Replace with your desired color */
                    border-radius: 50%; /* Makes the div circular */
                  "
                ></div>
                <div>WO</div>
                <div>Sedang Tindak Lanjut Over SLA</div>
              </th>
              <th
                scope="col"
                style="
                  font-size: 10px;
                  font-weight: 400;
                  line-height: 9.38px;
                  letter-spacing: 0.02em;
                  text-align: -webkit-center;
                "
              >
                <div
                  class="m-b-5"
                  style="
                    width: 10px; /* Adjust size of the dot */
                    height: 10px; /* Same as width to ensure a perfect circle */
                    background-color: #ffc772; /* Replace with your desired color */
                    border-radius: 50%; /* Makes the div circular */
                  "
                ></div>
                <div>WO</div>
                <div>WO Belum Tindak Lanjut</div>
              </th>
              <th
                scope="col"
                style="
                  font-size: 10px;
                  font-weight: 400;
                  line-height: 9.38px;
                  letter-spacing: 0.02em;
                  text-align: -webkit-center;
                "
              >
                <div
                  class="m-b-5"
                  style="
                    width: 10px; /* Adjust size of the dot */
                    height: 10px; /* Same as width to ensure a perfect circle */
                    background-color: #52cf8b; /* Replace with your desired color */
                    border-radius: 50%; /* Makes the div circular */
                  "
                ></div>
                <div>WO</div>
                <div>WO Sedang Tindak Lanjut</div>
              </th>
              <th
                scope="col"
                style="
                  font-size: 10px;
                  font-weight: 400;
                  line-height: 9.38px;
                  letter-spacing: 0.02em;
                  text-align: -webkit-center;
                "
              >
                <div
                  class="m-b-5"
                  style="
                    width: 10px; /* Adjust size of the dot */
                    height: 10px; /* Same as width to ensure a perfect circle */
                    background-color: #00a3e9; /* Replace with your desired color */
                    border-radius: 50%; /* Makes the div circular */
                  "
                ></div>
                <div>WO</div>
                <div>WO Selesai</div>
              </th>
            </tr>
          </thead>
          <tbody
            style="
              font-size: 14px;
              font-weight: 400;
              line-height: 16.41px;
              letter-spacing: 0.02em;
              text-align: center;
              color: #4e4e4e;
            "
          >
            <tr class="hover" v-for="item in workOrder">
              <th
                scope="row"
                v-if="item.name.includes('UID')"
                style="text-align: start"
              >
                <span
                  style="
                    background-color: #00a3e9;
                    padding: 1%;
                    color: white;
                    border-radius: 5px;
                  "
                  >General Manager</span
                >
                {{ item.name }}
              </th>
              <th
                scope="row"
                v-if="item.name.includes('UP3')"
                style="text-align: start"
              >
                <span
                  style="
                    background-color: #00a3e9;
                    padding: 1%;
                    color: white;
                    border-radius: 5px;
                  "
                  >Manager</span
                >
                {{ item.name }}
              </th>
              <th
                v-if="!item.name.includes('UP3') && !item.name.includes('UID')"
                scope="row"
                style="text-align: start"
              >
                {{ item.name }}
              </th>
              <td>
                <span @click="detail(item)" v-if="item.hasDetail" class="detail"
                  >DETAILS <i class="fa fa-angle-right"></i
                ></span>
              </td>
              <td>{{ formattedNumber(item.pendingOverSla) }}</td>
              <td>{{ formattedNumber(item.ongoingOverSla) }}</td>
              <td>{{ formattedNumber(item.pending) }}</td>
              <td>{{ formattedNumber(item.ongoing) }}</td>
              <td>{{ formattedNumber(item.completed) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import IconSvg from "@/components/IconSvg.vue";
import DistributionService from "@/services/distribution/distribution";
const apiDistribution = DistributionService.build();
import { formattedNumber } from "@/utils/helper";

export default {
  props: ["last_update"],
  components: {
    IconSvg,
  },
  data() {
    return {
      activeUid: false,
      activeUp3: false,
      activeUlp: false,
      uid: "",
      up3: "",
      ulp: "",
      idUId: "",
      idUp3: "",
      idUlp: "",
      workOrder: [],
    };
  },
  mounted() {
    this.getDataDistributionWorkOrder("");
  },
  methods: {
    async getDataDistributionWorkOrder(instance) {
      let param = Object.assign({
        instance: instance,
      });
      const res = await apiDistribution.getDataDistributionWorkOrder(param);
      if (res && res.status == 200) {
        this.workOrder = res.data.data;
      }
    },
    async getDataDistributionWorkOrderDetailRegionById(id) {
      let param = Object.assign({
        id: id,
      });
      const res =
        await apiDistribution.getDataDistributionWorkOrderDetailRegionById(
          param
        );
      if (res && res.status == 200) {
        this.workOrder = res.data.data;
      }
    },
    bread(x) {
      if (x === "all") {
        this.getDataDistributionWorkOrder("");
        this.uid = "";
        this.up3 = "";
        this.ulp = "";
      } else if (x === "up3") {
        this.getDataDistributionWorkOrder(this.idUid);
        this.ulp = "";
      } else if (x === "uid") {
        this.up3 = "";
        this.ulp = "";
        this.getDataDistributionWorkOrder(this.idUlp);
      } else {
        this.getDataDistributionWorkOrder(this.idUlp);
      }
    },
    detail(x) {
      const uid = x.name.includes("UID");
      const up3 = x.name.includes("UP3");
      if (uid) {
        this.activeUid = false;
        this.activeUp3 = true;
        this.activeUlp = false;
        this.idUid = x.id;
        this.up3 = x.name;
      } else if (up3) {
        this.activeUid = false;
        this.activeUp3 = false;
        this.activeUlp = true;
        this.idUp3 = x.id;
        this.ulp = x.name;
      } else {
        this.activeUid = true;
        this.activeUp3 = false;
        this.activeUlp = false;
        this.idUlp = x.id;
        this.uid = x.name;
      }

      this.getDataDistributionWorkOrder(x.id);
    },
    formattedNumber,
  },
};
</script>
<style>
.detail {
  display: none;
}

.hover:hover .detail {
  display: block;
  color: #00a3e9;
  cursor: pointer;
}
</style>
